


<div class="modal-content" *ngIf="Showsession">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-md-8">
          Add Session
        </div>
        <div class="col-md-4">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <div class="row my-pro-form margin-t-form">
        <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
          <div class="row">
            <div class="col-md-4 text-align-right">
              <label class="lab-size1"> Name </label>
            </div>
            <div class="col-md-6">

              <input type="text" class="form-control form-control-patient" placeholder="Name">


            </div>


          </div>

        </div>
      </div>

      <div class="row my-pro-form margin-t-form">
        <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
          <div class="row">
            <div class="col-md-4 text-align-right">
              <label class="lab-size1"> From Time </label>
            </div>
            <div class="col-md-6">

              <input type="time" class="form-control form-control-patient" placeholder="From Time">


            </div>


          </div>

        </div>
      </div>

      <div class="row my-pro-form margin-t-form">
        <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
          <div class="row">
            <div class="col-md-4 text-align-right">
              <label class="lab-size1"> To Time </label>
            </div>
            <div class="col-md-6">

              <input type="time" class="form-control form-control-patient" placeholder="To Time">


            </div>


          </div>

        </div>
      </div>

      <div class="row my-pro-form margin-t-form">
        <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
          <div class="row">
            <div class="col-md-4 text-align-right">
              <label class="lab-size1"> Total Duration </label>
            </div>
            <div class="col-md-6">

              <input type="number" class="form-control form-control-patient" placeholder="Total Duration">


            </div>


          </div>

        </div>
      </div>

      <div class="row my-pro-form margin-t-form">
        <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
          <div class="row">
            <div class="col-md-4 text-align-right">
              <label class="lab-size1"> Total Patients </label>
            </div>
            <div class="col-md-6">

              <input type="number" class="form-control form-control-patient" placeholder="Total Patients">


            </div>


          </div>

        </div>
      </div>

    </div>
    <div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>

  </div>
</div>




